import React, { useState } from "react"
import {
  Container,
  Header,
  Content,
  Navbar,
  Logo,
  Contact,
  ContactItem,
  Menu,
  MenuItem,
  MenuLink,
  ActionButton,
  MenuBarIcon,
} from "./style"
import { Icons, Modal, Search } from "components"

const NavigationBar = ({
  logo,
  phone,
  email,
  menu,
  actions,
  label,
}: INavigationBar) => {
  const [isOpenModal, setOpenModal] = useState(false)
  const [isOpenDrawer, setOpenDrawer] = useState(false)

  const onCloseModal = () => {
    setOpenModal(false)
  }

  return (
    <Container>
      <Header>
        <Content>
          <Logo>
            <img src={logo} alt="Logo" width={135} />
          </Logo>
          <Contact>
            <ContactItem>
              <span>
                <a href={`tel:${phone}`}>{phone}</a>
              </span>
            </ContactItem>
            <ContactItem>
              <span>
                <a href={`mailto:${email}`}>{email}</a>
              </span>
            </ContactItem>
          </Contact>
        </Content>
        <MenuBarIcon onClick={() => setOpenDrawer(true)}>
          <Icons.MenuBar width={20} height={20} />
        </MenuBarIcon>
        <Navbar visible={isOpenDrawer} onClose={() => setOpenDrawer(false)}>
          <Menu>
            {menu.map(({ name, url }, k) => (
              <MenuItem key={k}>
                <MenuLink to={url}>{name}</MenuLink>
              </MenuItem>
            ))}
            <MenuItem>
              <MenuLink
                to={"#"}
                onClick={(e: any) => {
                  e.preventDefault()
                  setOpenModal(true)
                }}
              >
                {"Search"}
              </MenuLink>
            </MenuItem>
            {actions.map(({ text, url }, k) => (
              <ActionButton key={k} to={url}>
                {text}
              </ActionButton>
            ))}
          </Menu>
        </Navbar>
      </Header>
      <Modal visible={isOpenModal} onCancel={onCloseModal}>
        <Search />
      </Modal>
    </Container>
  )
}

export default NavigationBar
